import React from "react";

import { AutocompleteItem } from "@components/Search/SearchAutocomplete/AutocompleteItem/autocompleteItem.container";
import { BaseItemProps } from "@components/Search/SearchAutocomplete/ResultsPanel/resultsPanel.templates";
import { ContentPagesSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";

type ContentPagesItemProps = BaseItemProps<ContentPagesSourceType>;

const ContentPagesItem = ({
    item,
    autocompleteState,
    autocompleteActions,
}: ContentPagesItemProps) => (
    <AutocompleteItem<ContentPagesSourceType>
        itemId={item.__autocomplete_id}
        href={item.externalPath}
        className={
            "rounded text-decoration-none text-reset truncate__wrapper d-flex align-items-center"
        }
        autocompleteState={autocompleteState}
        autocompleteActions={autocompleteActions}
    >
        <i className={"las la-arrow-right pr-2"}></i>
        <span className={"truncate"}>{item.title}</span>
    </AutocompleteItem>
);

export { ContentPagesItem };
